import React from "react"
import PortfolioCard from "components/portfolioCard"
import Button from "components/button"
import ImageConstant from "utils/imageConstant"
import styles from "./portfolios.module.scss"

const PROJECTS_DATA = [
  {
    title: "ProgressMates",
    role: "Founder & Full Stack Developer",
    image: ImageConstant.PROGRESSMATES_LOGO,
    description:
      "Enterprise-grade ERP and financial analytics SaaS for real estate developers and contractors. Automate Running Account (RA) billing, track central stock allocations, calculate contractor TDS, and audit global ledgers in real-time.",
    techTags: ["React", "Node.js", "TypeScript", "MongoDB", "Express", "SaaS"],
    featured: true,
    buttons: [
      { text: "Visit Site", link: "https://www.progressmates.com/" },
      {
        text: "PlayStore",
        link: "https://play.google.com/store/apps/details?id=com.facility_mobile_app",
      },
    ],
  },
  {
    title: "Jago - Digital Bank",
    role: "Software Developer (via Coditas)",
    image: ImageConstant.JAGO_LOGO,
    description:
      "Built an OCR system to extract information from identification cards, automating the onboarding process and cutting registration time from 5 minutes to 30 seconds. Implemented KYC process and internationalization.",
    techTags: ["Flutter", "REST APIs", "OCR", "KYC Integration"],
    buttons: [
      {
        text: "PlayStore",
        link: "https://play.google.com/store/apps/details?id=com.jago.digitalBanking&hl=en_US",
      },
      {
        text: "AppStore",
        link: "https://apps.apple.com/id/app/bank-jago-jago-syariah/id1539402234",
      },
    ],
  },
  {
    title: "Green Chick Chop",
    role: "Software Developer",
    image: ImageConstant.GREENCHICKCHOP_LOGO,
    description:
      "Built an end-to-end food delivery application with a responsive and mobile-friendly UI. Assisted vendors in streamlining their checkout/ordering flow, increasing overall sales by 60%.",
    techTags: ["ReactJS", "NodeJS", "MongoDB", "Responsive UI"],
    buttons: [{ text: "Visit Site", link: "https://www.greenchickchop.in/" }],
  },
  {
    title: "Heirship",
    role: "Software Developer",
    image: ImageConstant.HEIRSHIP_ICON,
    description:
      "Photo aggregation and analytics tool that aggregates images from multiple cloud storage accounts, generating duplicate photo detection and space usage insights.",
    techTags: ["React", "Cloud Storage APIs", "Image Processing", "Analytics"],
  },
  {
    title: "Craftsman Republic",
    role: "Software Developer",
    image: ImageConstant.CRAFTSMAN_IMAGE,
    description:
      "App providing everything craftsmen need to sign-up, receive, and manage pre-paid work orders across the United States.",
    techTags: ["React Native", "Android", "iOS", "APIs"],
  },
  {
    title: "Bandhan",
    role: "Software Developer",
    image: ImageConstant.BANDHAN_IMAGE,
    description:
      "A mobile application connecting healthcare camps across India, enabling the team to register patients, coordinate camp activities, and track distribution of medicines.",
    techTags: ["React Native", "Android", "API Integration", "Healthcare"],
  },
  {
    title: "Kiddo",
    role: "Software Developer",
    image: ImageConstant.KIDDO_ICON,
    description:
      "Personalized smart health platform for children, offering insights, wellness monitoring, and tailored healthcare tracking.",
    techTags: ["React Native", "iOS", "Android", "HealthTech"],
  },
]

function Portfolios() {
  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <div className={styles.header}>
          <p className={styles.subtitle}>Portfolios</p>
          <h2 className={styles.title}>
            Featured <span className={styles.gradient}>Projects</span>
          </h2>
        </div>

        <div className={styles.grid}>
          {PROJECTS_DATA.map((project, index) => (
            <PortfolioCard
              key={index}
              emoji={project.emoji}
              image={project.image}
              title={project.title}
              role={project.role}
              description={project.description}
              techTags={project.techTags}
              link={project.link}
              featured={project.featured}
            >
              {project.buttons &&
                project.buttons.map((btn, btnIdx) => (
                  <Button key={btnIdx} buttonText={btn.text} link={btn.link} />
                ))}
            </PortfolioCard>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Portfolios
